import { createRouter, createWebHistory } from 'vue-router'
import AppLayout from '@/layout/AppLayout.vue'
import home from '@/view/home'
import agent from '@/view/agent'
import commissions from '@/view/commissions'
import futures from '@/view/futures'
import withdrawMoney from '@/view/withdrawMoney'
import user from '@/view/user'

const Test = () => import('@/components/table/Test.vue')
const Home = () => import('@/view/home/Home.vue')

const routerHistory = createWebHistory()
const routes = [
  { path: '', redirect: '/Home' },
  user.routes,
  {
    path: '',
    component: AppLayout,
    children: [
      home.routes,
      agent.routes,
      commissions.routes,
      futures.routes,
      withdrawMoney.routes,
      {
        path: '/test',
        component: Test,
      },
      // {
      //   path: '/Home',
      //   name: 'Home',
      //   meta: {
      //     title: '首页概览'
      //   },
      //   component: Home,
      // }

      // {
      //   path: '/home',
      //   component: Home,
      // },
    ]
  },
  {
    path: '/404',
    name: 'notfound',
    component: { render: () => '404' },
    hidden: true,
  }
]

const router = createRouter({
  history: routerHistory,
  routes
})

// router.onError((error, to) => {
//   if (
//     error.message.includes('Failed to fetch dynamically imported module') ||
//     error.message.includes('Importing a module script failed') ||
//     error.message.includes('error loading dynamically imported module')
//   ) {
//     if (!to?.fullPath) {
//       window.location.reload()
//     } else {
//       window.location = to.fullPath
//     }
//   }
// }
// )

router.beforeEach(async (to, from, next) => {
  const token = localStorage.token
  // if (!token) {
  // next({
  //   path: '/Login'
  // })
  // } else {
  next()
  // }
})

export default router
